import { render, staticRenderFns } from "./Magazzino.vue?vue&type=template&id=f1c3ce78&scoped=true&"
import script from "./Magazzino.vue?vue&type=script&lang=js&"
export * from "./Magazzino.vue?vue&type=script&lang=js&"
import style0 from "./Magazzino.vue?vue&type=style&index=0&id=f1c3ce78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c3ce78",
  null
  
)

export default component.exports